import loadModuleOnElement from "../../utils/loadModuleOnElement";

const loader = () => import("./nativeTalk");

export default function nativeTalkLoader(context) {
    loadModuleOnElement(".community-native-wrp", loader, context);
    return context;
}
